import { useMemo } from 'react';

import jwtDecode from 'jwt-decode';

import { currentJwt } from '@src/utils/jwtHelpers';

const useUserInfo = () => {
    const jwt = currentJwt();
    return useMemo(() => {
        const decodedJWT = jwtDecode(jwt);
        if (!decodedJWT) {
            return {
                agentCode: null,
                producerId: null,
                accessLevel: null,
                premierAccess: null,
                salesChannel: null,
                exp: null,
                permissions: null,
                agencyName: null,
                agencyMainId: null,
                agencyMdfAllocation: null,
            };
        }

        return {
            agentCode: decodedJWT.agent_code,
            producerId: decodedJWT.producer_id,
            accessLevel: decodedJWT.access_level,
            premierAccess: decodedJWT.premier_access,
            salesChannel: decodedJWT.sales_channel,
            exp: decodedJWT.exp,
            permissions: decodedJWT.permissions,
            agencyName: decodedJWT.agency_name,
            agencyMainId: decodedJWT.agency_main_id,
            agencyMdfAllocation: decodedJWT.agency_mdf_allocation,
        };
    }, [jwt]);
};

export { useUserInfo };
